/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown>, count: NonNullable<unknown> }} Chat_Activity_Panel_PositionInputs */



/**
* | output |
* | --- |
* | "{position} of {count}" |
*
* @param {Chat_Activity_Panel_PositionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_panel_position = /** @type {((inputs: Chat_Activity_Panel_PositionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Panel_PositionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.position} van ${i?.count}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.position} sur ${i?.count}`)
	return /** @type {LocalizedString} */ (`${i?.position} of ${i?.count}`)
});